var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_674_3903)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H36C37.6569 1 39 2.34315 39 4V36C39 37.6569 37.6569 39 36 39H4C2.34315 39 1 37.6569 1 36V4C1 2.34315 2.34315 1 4 1Z",
    fill: "white",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_674_3903",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H10V30H30V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_674_3903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6 20.2274C29.6 19.5183 29.5364 18.8365 29.4182 18.1819H20V22.0501H25.3818C25.15 23.3001 24.4455 24.3592 23.3864 25.0683V27.5774H26.6182C28.5091 25.8365 29.6 23.2728 29.6 20.2274Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 29.9999C22.6999 29.9999 24.9635 29.1044 26.618 27.5772L23.3862 25.0681C22.4908 25.6681 21.3453 26.0226 19.9999 26.0226C17.3953 26.0226 15.1908 24.2635 14.4044 21.8999H11.0635V24.4908C12.709 27.759 16.0908 29.9999 19.9999 29.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4045 21.8999C14.2045 21.2999 14.0909 20.659 14.0909 19.9999C14.0909 19.3408 14.2045 18.6999 14.4045 18.0999V15.509H11.0636C10.3864 16.859 10 18.3863 10 19.9999C10 21.6135 10.3864 23.1408 11.0636 24.4908L14.4045 21.8999Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 13.9773C21.468 13.9773 22.7862 14.4818 23.8226 15.4727L26.6908 12.6045C24.959 10.9909 22.6953 10 19.9999 10C16.0908 10 12.709 12.2409 11.0635 15.5091L14.4044 18.1C15.1908 15.7364 17.3953 13.9773 19.9999 13.9773Z",
    fill: "#E94235"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_674_3903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogin);
export default __webpack_public_path__ + "static/media/google_login.1166a136fbe7104de50d8d432c76136d.svg";
export { ForwardRef as ReactComponent };